<template>
  <a-card :bordered="false">
    <div class="card-title">企业制度</div>
    <div class="table-operator">
      <a-button v-action:add type="primary" icon="plus" @click="handleAdd">新增制度</a-button>
      <SearchForm ref="SearchForm" @handleSubmit="handleSeachSubmit"/>
    </div>
    <s-table
        ref="table"
        rowKey="system_id"
        :loading="isLoading"
        :columns="columns"
        :data="loadData"
        :pageSize="15"
    >
      <div slot="personnel_type" slot-scope="text, item">
        <a-tag color="blue" v-if="item.personnel_type==0">司机</a-tag>
        <a-tag color="orange" v-if="item.personnel_type==1">押运员</a-tag>
      </div>
      <div slot="status" slot-scope="text, item">
        <a-tag color="orange" v-if="text===0">待签名</a-tag>
        <a-tag color="blue" v-if="text===1">已签名</a-tag>
      </div>
      <div class="actions" slot="action" slot-scope="text, item">
        <a v-action:show @click="showViewlog(item)">查阅信息</a>
        <a v-action:edit @click="handleEdit(item)">编辑</a>
        <a v-action:delete @click="handleDelete(item)">删除</a>
      </div>
    </s-table>
    <SaveForm ref="SaveForm" @handleSubmit="handleRefresh"/>
    <ViewlogModel ref="ViewlogModel" @handleSubmit="handleRefresh"/>
  </a-card>
</template>

<script>
import * as Api from '@/api/enterprise/system'
import {STable} from '@/components'
import SaveForm from './modules/SaveForm'
import ViewlogModel from './viewlog/Index'
import SearchForm from './modules/SearchForm'
import {isEmpty} from "@/utils/util";

export default {
  name: 'Index',
  components: {
    STable,
    SaveForm,
    SearchForm,
    ViewlogModel
  },
  data() {
    return {
      // 查询参数
      queryParam: {},
      // 正在加载
      isLoading: false,
      // 表头
      columns: [
        {
          title: '制度标题',
          dataIndex: 'system_title',
        },
        // {
        //   title: '职位',
        //   dataIndex: 'personnel.personnel_type',
        //   scopedSlots: {customRender: 'personnel_type'}
        // },
        // {
        //   title: '合同状态',
        //   dataIndex: 'status',
        //   scopedSlots: {customRender: 'status'}
        // },
        // {
        //   title: '签名时间',
        //   dataIndex: 'sign_time'
        // },
        {
          title: '创建时间',
          dataIndex: 'create_time'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '180px',
          scopedSlots: {customRender: 'action'}
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: param => {
        return Api.list({...param, ...this.queryParam})
            .then(response => {
              return response.data.list
            })
      },
    }
  },
  created() {

  },
  methods: {
    isEmpty,
    /**
     * 新增记录
     */
    handleAdd() {
      this.$refs.SaveForm.add()
    },

    /**
     * 编辑记录
     */
    handleEdit(item) {
      this.$refs.SaveForm.edit(item)
    },
    showViewlog(item) {
      this.$refs.ViewlogModel.open(item.system_id)
    },
    /**
     * 删除记录
     */
    handleDelete(item) {
      const app = this
      const modal = this.$confirm({
        title: '您确定要删除该记录吗?',
        content: '删除后不可恢复',
        onOk() {
          return Api.deleted({system_id: item['system_id']})
              .then((result) => {
                app.$message.success(result.message, 1.5)
                app.handleRefresh()
              })
              .finally(result => {
                modal.destroy()
              })
        }
      })
    },

    handleSeachSubmit(value) {
      this.queryParam = {
        ...this.queryParam,
        ...value
      }
      this.handleRefresh(true)
    },

    /**
     * 刷新列表
     * @param Boolean bool 强制刷新到第一页
     */
    handleRefresh(bool = false) {
      this.$nextTick(() => {
        this.$refs.table.refresh(bool)
      })
    },

    /**
     * 检索查询
     */
    onSearch() {
      this.handleRefresh(true)
    }

  }
}
</script>
